export function escapeRegExp(str) {
  // eslint-disable-next-line no-useless-escape
  return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}